import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  // Which tab of the create-workflow picker is active. Persisting in the URL
  // means the picker state survives reloads, supports the back button, and
  // makes share-links land users on the right mode.
  mode: z.enum(['describe', 'template', 'build']).optional(),
})

export const Route = createFileRoute('/_protected/studio/')({
  validateSearch: searchSchema,
  component: lazyRouteComponent(() => import('@/pages/studio-mock/page'), 'Studio'),
})
